var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#0D2481"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5395 33.5835L34.2697 43.1671L49.5395 52.7506L34.2697 62.3342L19 52.6988L34.2697 43.1153L19 33.5835L34.2697 24L49.5395 33.5835ZM34.1908 65.4165L49.4605 55.8329L64.7303 65.4165L49.4605 75L34.1908 65.4165ZM49.5395 52.6988L64.8092 43.1153L49.5395 33.5835L64.7303 24L80 33.5835L64.7303 43.1671L80 52.7506L64.7303 62.3342L49.5395 52.6988Z",
    fill: "#D9F8FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/Dropbox.4945b2d8af5eb9b6f876c08d411e7de1.svg";
export { ForwardRef as ReactComponent };